import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import {
  Megaphone, Briefcase, Calendar, Newspaper, Image, Projector, UserCheck
} from "lucide-react";

import "./ManageAlumniPage.css";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

export default function ManageAlumniPage() {
  const navigate = useNavigate();

  const [serverTime, setServerTime] = useState({ fullDateTime: "" });
  const [currentUser, setCurrentUser] = useState({ fullname: "", systemRole: "" });

  // Load logged-in user safely
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setCurrentUser({
        fullname: user.fullname,
        systemRole: user.systemRole,
      });
    }
  }, []);

  // Fetch server date & time
  const fetchServerTime = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/time/datetime`);
      if (res.data.success) setServerTime(res.data);
    } catch (err) {
      console.error("Failed to fetch server time:", err.message);
    }
  };

  useEffect(() => {
    fetchServerTime();
  }, []);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      month: "short", day: "2-digit", year: "numeric",
    });
  };

  const formatTime = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleTimeString("en-US", {
      hour: "numeric", minute: "2-digit", hour12: true,
    });
  };

  // Action buttons
  const actions = [
    { title: "Announcement Page", icon: Megaphone, path: "/admin-panel/announcement-page" },
    { title: "Job Page", icon: Briefcase, path: "/admin-panel/jobs-page" },
    { title: "Event Page", icon: Calendar, path: "/admin-panel/events-page" },
    { title: "News Page", icon: Newspaper, path: "/admin-panel/news-page" },
    { title: "Gallery Page", icon: Image, path: "/admin-panel/gallery-page" },
    { title: "Project & Initiatives Page", icon: Projector, path: "/admin-panel/projects-page" },
    { title: "Talent Pool Page", icon: UserCheck, path: "/admin-panel/talent-pool" },
  ];

  return (
    <div className="manage-page">
      {/* USER INFO */}
      <div className="manage-user-card">
        <div className="manage-user-left">
          <div className="manage-user-name">Welcome, {currentUser.fullname}</div>
          <div className="manage-user-role">System Role: {currentUser.systemRole}</div>
        </div>
        <div className="manage-user-right">
          <div className="manage-user-date">{formatDate(serverTime.fullDateTime)}</div>
          <div className="manage-user-time">{formatTime(serverTime.fullDateTime)}</div>
        </div>
      </div>

      {/* PAGE TITLE */}
      <h1 className="manage-page-title">Manage Alumni & Administration</h1>

      {/* ACTION BUTTONS */}
      <div className="manage-actions-row">
        {actions.map((act) => (
          <motion.button
            key={act.title}
            className="manage-btn-action"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => navigate(act.path)}
          >
            <act.icon size={20} style={{ marginRight: "8px" }} />
            {act.title}
          </motion.button>
        ))}
      </div>
    </div>
  );
}